import BodyType from 'owa-service/lib/contract/BodyType';
import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import Item from 'owa-service/lib/contract/Item';
import postGroupItemOperation from 'owa-service/lib/operation/postGroupItemOperation';
import postGroupItemRequest from 'owa-service/lib/factory/postGroupItemRequest';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBodyFromItem(
    groupId: string,
    itemType: Item,
    bodyType: BodyType,
    timeFormat: string,
    isInlineCompose?: boolean
) {
    const request = postGroupItemRequest({
        ModernGroupEmailAddress: {
            EmailAddress: groupId,
            MailboxType: 'GroupMailbox',
        },
        ClientSupportsIrm: true,
        ComposeOperation: 'newPost',
        MessageDisposition: 'SendAndSaveCopy',
        OutboundCharset: 'AutoDetect',
        Items: [itemType],
        TimeFormat: timeFormat,
        ItemShape: itemResponseShape({
            // Pass IdOnly as ShapeName here so that the response will contain LastModifiedTime
            BaseShape: 'IdOnly',
            AdditionalProperties: [propertyUri({ FieldURI: 'ItemLastModifiedTime' })],
        }),
    });

    if (isInlineCompose) {
        // If sending from inlineCompose, request the internetMessageId in case we don't have it yet.
        request.ItemShape.ReturnOnlyInternetMessageId = true;
    }

    return request;
}

export default function postGroupItem(
    groupId: string,
    itemType: Item,
    bodyType: BodyType,
    timeFormat: string,
    isInlineCompose?: boolean
): Promise<CreateItemResponse> {
    const requestBody = createRequestBodyFromItem(
        groupId,
        itemType,
        bodyType,
        timeFormat,
        isInlineCompose
    );

    return postGroupItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response
            ? Promise.resolve(response.Body)
            : Promise.reject(new Error('ErrorSessionTimeout')); // When get HTTP 401/440, the response will be null
    });
}
